// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2sMPs","validationTips":"StatementDescriptor_validationTips__2xq4P"};